import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <div className="container">
          <h1 className="hero-title fade-in">
            Industrial Packaging Solutions for Various Applications
          </h1>
          <p className="hero-description fade-in">
            Specialized in packaging and shipping large-scale industrial products with precision and care
          </p>
          <button className="hero-cta fade-in" onClick={scrollToContact}>
            Request a Quote
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
